export default function CustomStore(options = {}) {
  this.key = options.key;
  this.load = (loadOptions = {}, requestOptions) =>
    Promise.resolve(options.load ? options.load(loadOptions, requestOptions) : []);

  if (options.byKey) this.byKey = key => Promise.resolve(options.byKey(key));
  if (options.totalCount)
    this.totalCount = loadOptions => Promise.resolve(options.totalCount(loadOptions));
  if (options.loadMode) this.loadMode = options.loadMode;
}
